/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiExtFixPayoutGet } from '../fn/ext/api-ext-fix-payout-get';
import { ApiExtFixPayoutGet$Params } from '../fn/ext/api-ext-fix-payout-get';
import { apiExtResetSeqCounterGet$Json } from '../fn/ext/api-ext-reset-seq-counter-get-json';
import { ApiExtResetSeqCounterGet$Json$Params } from '../fn/ext/api-ext-reset-seq-counter-get-json';
import { apiExtResetSeqCounterGet$Plain } from '../fn/ext/api-ext-reset-seq-counter-get-plain';
import { ApiExtResetSeqCounterGet$Plain$Params } from '../fn/ext/api-ext-reset-seq-counter-get-plain';

@Injectable({ providedIn: 'root' })
export class ExtService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiExtResetSeqCounterGet()` */
  static readonly ApiExtResetSeqCounterGetPath = '/api/Ext/resetSeqCounter';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExtResetSeqCounterGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExtResetSeqCounterGet$Plain$Response(params?: ApiExtResetSeqCounterGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return apiExtResetSeqCounterGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExtResetSeqCounterGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExtResetSeqCounterGet$Plain(params?: ApiExtResetSeqCounterGet$Plain$Params, context?: HttpContext): Observable<Array<string>> {
    return this.apiExtResetSeqCounterGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExtResetSeqCounterGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExtResetSeqCounterGet$Json$Response(params?: ApiExtResetSeqCounterGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return apiExtResetSeqCounterGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExtResetSeqCounterGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExtResetSeqCounterGet$Json(params?: ApiExtResetSeqCounterGet$Json$Params, context?: HttpContext): Observable<Array<string>> {
    return this.apiExtResetSeqCounterGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `apiExtFixPayoutGet()` */
  static readonly ApiExtFixPayoutGetPath = '/api/Ext/fixPayout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExtFixPayoutGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExtFixPayoutGet$Response(params?: ApiExtFixPayoutGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiExtFixPayoutGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExtFixPayoutGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExtFixPayoutGet(params?: ApiExtFixPayoutGet$Params, context?: HttpContext): Observable<void> {
    return this.apiExtFixPayoutGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
